angular.module('impactx.panel').controller('ThemeworldPreviewPanelCtrl', [
    '$scope',
    ThemeworldPreviewPanelCtrl]);

function ThemeworldPreviewPanelCtrl($scope) {
    var self = this;
    if(!self.trns) {
        self.trns = {};
    }

    self.deleteImage = function(event) {
        if(event) {
            event.stopPropagation();
            event.preventDefault();
        }
        self.image.isDeleted = true;
        self.image.file = undefined;
        self.image.url = "img/missing-image.jpg";
    };

    $scope.$watch(function() {
        return impactX.isDefined(self, "image.file");
    }, function(newValue, oldValue) {
        if(newValue && !angular.equals(newValue, oldValue)) {
            self.image.isDeleted = true;
        }
    });
}